import type {Connection} from '@package/shared'
import {IconBrandGithub, IconCalendar, IconLayoutKanban, type IconProps} from '@tabler/icons-react'

type Props = {
  type: Connection['type']
} & IconProps

export const ConnectionTypeIcon = ({type, ...rest}: Props) => {
  return {
    'ical-subscription': <IconCalendar size={18} stroke={1} {...rest} />,
    'github-api': <IconBrandGithub size={18} stroke={1} {...rest} />,
    'jira-api': <IconLayoutKanban size={18} stroke={1} {...rest} />,
  }[type]
}
